<template>
    <!-- 레이어 팝업 .ev_a7070xgli_pop1 이벤트 이전 시작 -->
    <div class="layerWrapper" v-bind:class="getStyle">
      <div class="cbox layerBox popWidM">
        <div class="cart-popup__dialog">
          <div class="cart-popup__content height-auto">
            <div class="cart-popup__item-info" style="padding:0">
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'begin'">
                <img src="../images/a7070xgri_pop1.jpg" style="width:100%;" alt="본 이벤트는 이벤트 신청 시간부터 신청 가능합니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'joinCompleted'">
                <img src="../images/a7070xgri_pop2.jpg" style="width:100%;" alt="이벤트 신청이 완료되었습니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'closed'">
                <img src="../images/a7070xgri_pop3.jpg" style="width:100%;" alt="본 이벤트는 종료되어 신청하실 수 없습니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'validTerms'">
                <img src="../images/a7070xgri_pop4.jpg" style="width:100%;" alt="개인정보 수집 동의를 해야만 참여가 가능합니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'joinIn'">
                <img src="../images/a7070xgri_pop5.jpg" style="width:100%;" alt="이미 이벤트에 응모하셨습니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'validPhone'">
                <img src="../images/a7070xgri_pop6.jpg" style="width:100%;" alt="개인정보 수집 동의를 해야만 참여가 가능합니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'notJoin'">
                <img src="../images/a7070xgri_pop7.jpg" style="width:100%;" alt="개인정보 수집 동의를 해야만 참여가 가능합니다.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'validName'">
                <img src="../images/a7070xgri_pop8.jpg" style="width:100%;" alt="이름을 입력하여 주세요.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'validPhoneEmpty'">
                <img src="../images/a7070xgri_pop9.jpg" style="width:100%;" alt="핸드폰 번호를 입력하여 주세요.">
              </div>
              <div class="os_noticeRes" data-btn-close="closeLayer" v-show="isMode == 'validAboNumber'">
                <img src="../images/a7070xgri_pop10.jpg" style="width:100%;" alt="ABO/Member/소비자번호를 입력하여 주세요.">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //레이어 팝업 .ev_a7070xgli_pop1 이벤트 이전 끝 -->
    
</template>

<script>

export default {
  name: "a7070-glister-layer-popup",
  props: ['layers'],
  computed : { 
    getStyle () { 
      return this.layers.mode[this.layers.selectItem]
    },
    isMode() { 
      return this.layers.selectItem 
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/views/nutrilite/a7070-glister/component/layerPopup.vue